import React from "react";
import { UIFlightData } from "@flights/types";
import useRyanairHungaryInfoController from "./useRyanairHungaryInfo.controller";
import { Icon, Stack, Text } from "@bookingcom/bui-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";

const useRyanairHungaryInfo = (flight: UIFlightData) => {
  const { header, ryanairHungarytext } = useRyanairHungaryInfoController(flight);

  if (!ryanairHungarytext) return undefined;

  return {
    header,
    content: (
      <Stack direction="row" gap={4}>
        <Icon svg={InfoSignIcon} size="large" />
        <Stack.Item grow={true}>
          <Text variant="body_2">{ryanairHungarytext}</Text>
        </Stack.Item>
      </Stack>
    )
  };
};

export default useRyanairHungaryInfo;
